export class DatatableConfig {
  public static spanish_datatables = {
    processing: "Procesando...",
    search: "",
    searchPlaceholder: "Buscar",
    lengthMenu: "Mostrar _MENU_ elementos",
    info: "Mostrando desde _START_ al _END_ de _TOTAL_ elementos",
    infoEmpty: "Mostrando ningún elemento.",
    infoFiltered: "(filtrado _MAX_ elementos total)",
    infoPostFix: "",
    loadingRecords: "Cargando registros...",
    zeroRecords: "No se encontraron registros",
    emptyTable: "No hay datos disponibles en la tabla",
    paginate: {
      first: "Primero",
      previous: "Anterior",
      next: "Siguiente",
      last: "Último"
    },
    aria: {
      sortAscending: ": Activar para ordenar la tabla en orden ascendente",
      sortDescending: ": Activar para ordenar la tabla en orden descendente"
    }
  }
  public static readonly spanish_datatables2 = {
    processing: "Procesando...",
    search: "Buscar: ",
    searchPlaceholder: "Buscar",
    lengthMenu: "Mostrar _MENU_ elementos",
    info: "Mostrando desde _START_ al _END_ de _TOTAL_ elementos",
    infoEmpty: "Mostrando ningún elemento.",
    infoFiltered: "(filtrado _MAX_ elementos total)",
    infoPostFix: "",
    loadingRecords: "Cargando registros...",
    zeroRecords: "No se encontraron registros",
    emptyTable: "No hay datos disponibles en la tabla",
    paginate: {
      first: "Primero",
      previous: "Anterior",
      next: "Siguiente",
      last: "Último"
    },
    aria: {
      sortAscending: ": Activar para ordenar la tabla en orden ascendente",
      sortDescending: ": Activar para ordenar la tabla en orden descendente"
    }
  }

  public static drawCallBackFn = () => {
    $('.bottom').css("margin-top", "1%");
    $(".paginate_button").css("background", "none").css("border-radius", "4px").css("padding", "0.3em 0.7em").css("font-size","1.4rem").css("opacity","1 !important");
    $(".paginate_button").hover(function () {
      $(this).css('cssText', 'color: black !important; background: none; border-radius: 4px; padding: 0.3em 0.7em; font-size:1.4rem')
    });
    $('#dataTables_filter input').val('')
  }

  //dt Lista usuarios
  public static dtOptionsFixedRightColumn = {
    pagingType: 'simple_numbers',
    pageLength: 10,
    lengthMenu: [[5, 10, 20, -1] , [5, 10, 20, 100]],
    processing: true,
    searching: true,
    scrollX: true,
    autoWidth: false,
    fixedColumns: {
      left: 0,
      right: 1
    },
    dom: "<'pull-left'f>t<'bottom'>lp",
    language: this.spanish_datatables,
    "drawCallback": this.drawCallBackFn,
  }

  public static dtOptionsWithPopOver = {
    pagingType: 'simple_numbers',
    pageLength: 10,
    lengthMenu: [[5, 10, 20, -1] , [5, 10, 20, 100]],
    processing: true,
    searching: true,
    scrollX: false,
    autoWidth: false,
    dom: "<'pull-left'f>t<'bottom'>lp",
    language: this.spanish_datatables,
    "drawCallback": this.drawCallBackFn
  }


  public static dtOptionDefaultSearchLeft = {
    pagingType: 'simple_numbers',
    pageLength: 10,
    lengthMenu: [[5, 10, 20, -1] , [5, 10, 20, 100]],
    processing: true,
    searching: true,
    scrollX: true,
    autoWidth: false,
    dom: "<'pull-left'f>t<'bottom'>lp",
    language: this.spanish_datatables,
    "drawCallback": () => {
      $(".th-mensaje-observaciones").css("cssText", "max-width: 210px")
      $(".dataTables_filter").addClass('ocultar-mobile')
    },
  }

  public static dtOptionDefaultSearchLeftDesc = {
    pagingType: 'simple_numbers',
    pageLength: 10,
    lengthMenu: [[5, 10, 20, -1] , [5, 10, 20, 100]],
    processing: true,
    searching: true,
    scrollX: true,
    autoWidth: false,
    ordering:false,
    dom: "<'pull-left'f>t<'bottom'>lp",
    language: this.spanish_datatables,
    "drawCallback": this.drawCallBackFn,
  }

  public static simpledt = {
    pagingType: 'simple_numbers',
    pageLength: 10,
    lengthMenu: [10, 20, 30, 40, 50],
    processing: true,
    searching: true,
    dom: "<'top'>t<'bottom'lp><'clear'>",
    language: this.spanish_datatables,
    "drawCallback": this.drawCallBackFn,
  }

  public static calificacionesDt = {
    pagingType: 'simple_numbers',
    processing: true,
    searching: false,
    paging: false,
    ordering:false,
    info:false,
    autoWidth:true,
    responsive:true,
    // lengthChange: false,
    columns:[
      { width:'20px' },
      { width:'90px'},
      { width:'120px' },
      { width:'30px' },
      { width:'30px' },
      { width:'30px' },
      { width:'30px' },
      { width:'30px' },
      { width:'30px' },
      { width:'30px' },
      { width:'30px' },
      { width:'10px' },
      { width:'auto' },
    ],
    language: {
      "emptyTable": "No hay información",
      "lengthMenu": "Viendo _MENU_ Entradas",
      "loadingRecords": "Cargando...",
      "processing": "Procesando...",
      "search": "Buscar:",
      "zeroRecords": "Sin resultados encontrados",
      "paginate": {
        "first": "Primero",
        "last": "Ultimo",
        "next": "Siguiente",
        "previous": "Anterior"
      },
      searchPlaceholder: "Nombre o RUT"
    }
  }

  public static dtOptionsFixedLeftColumnCalificaciones = {
    pagingType: 'simple_numbers',
    processing: true,
    searching: false,
    scrollX: true,
    autoWidth: false,
    paging: false,
    ordering: false,
    // fixedHeader: true,
    fixedColumns: {
      left: 3,
      right: 0
    },
    dom: "<'pull-right'f>t<'bottom'>lp",
    language: {
      "emptyTable": "No hay información",
      "lengthMenu": "Viendo _MENU_ Entradas",
      "loadingRecords": "Cargando...",
      "processing": "Procesando...",
      "search": "Buscar:",
      "zeroRecords": "Sin resultados encontrados",
      "paginate": {
        "first": "Primero",
        "last": "Ultimo",
        "next": "Siguiente",
        "previous": "Anterior"
      },
      searchPlaceholder: "Nombre o RUT"
    },
    "drawCallback": () => {
      // $(".dtfc-fixed-left").css("cssText", "background-color: black !important;")
      $(".width-pond").css("cssText", "min-width: 30px")
      $(".th-anotaciones").css("cssText", "min-width: 110px")
      $(".dataTables_filter").addClass('ocultar-mobile')
    },
  }

  public static dtOptionsCalificacionesNotFixed = {
    pagingType: 'simple_numbers',
    processing: true,
    searching: false,
    autoWidth: false,
    paging: false,
    ordering: false,
    // fixedHeader: true,
    dom: "<'pull-right'f>t<'bottom'>lp",
    language: {
      "emptyTable": "No hay información",
      "lengthMenu": "Viendo _MENU_ Entradas",
      "loadingRecords": "Cargando...",
      "processing": "Procesando...",
      "search": "Buscar:",
      "zeroRecords": "Sin resultados encontrados",
      "paginate": {
        "first": "Primero",
        "last": "Ultimo",
        "next": "Siguiente",
        "previous": "Anterior"
      },
      searchPlaceholder: "Nombre o RUT"
    },
    "drawCallback": () => {
      // $(".dtfc-fixed-left").css("cssText", "background-color: black !important;")
      $(".width-pond").css("cssText", "min-width: 30px")
      $(".th-anotaciones").css("cssText", "min-width: 110px")
      $(".dataTables_filter").addClass('ocultar-mobile')
    },
  }

  public static dtOptionsFixedRightLastColumn = {
    pagingType: 'simple_numbers',
    processing: true,
    searching: false,
    scrollX: true,
    // autoWidth: false,
    paging: false,
    ordering: false,
    // fixedHeader: true,
    fixedColumns: {
      left: 0,
      right: 0
    },
    dom: "<'pull-right'f>t<'bottom'>lp",
    language: {
      "emptyTable": "No hay información",
      "lengthMenu": "Viendo _MENU_ Entradas",
      "loadingRecords": "Cargando...",
      "processing": "Procesando...",
      "search": "Buscar:",
      "zeroRecords": "Sin resultados encontrados",
      "paginate": {
        "first": "Primero",
        "last": "Ultimo",
        "next": "Siguiente",
        "previous": "Anterior"
      },
      searchPlaceholder: "Nombre o RUT"
    },
    "drawCallback": () => {
      // $(".dtfc-fixed-left").css("cssText", "background-color: black !important;")
      // $(".width-pond").css("cssText", "min-width: 30px")
      // $(".th-anotaciones").css("cssText", "min-width: 110px")
      $(".dataTables_filter").addClass('ocultar-mobile')
      $(".dtfc-fixed-right").css("cssText", "background-color: black !important;")
    },
  }

  public static dtSortWithoutSearch = {
    pagingType: 'simple_numbers',
    pageLength: 5,
    lengthMenu: [5, 10, 20, 30, 40, 50],
    processing: true,
    searching: true,
    dom: 
      "<'top'>t<'bottom'lp><'clear'>",
      "drawCallback": this.drawCallBackFn,
    language: this.spanish_datatables
  }

  public static dtSortWithoutSearch_2 = {
    pagingType: 'simple_numbers',
    pageLength: 10,
    lengthMenu: [10, 20, 30, 40, 50, 100],
    processing: true,
    searching: true,
    order: [[0, 'desc']],
    dom: 
      // "<'top'>t<'bottom'lp><'clear'>",
      "<'pull-left'f>t<'bottom'>lp",
      "drawCallback": this.drawCallBackFn,
    language: this.spanish_datatables
  }

  public static dtExclusionAsignaturas = {
    pagingType: 'simple_numbers',
    pageLength: 10,
    lengthMenu: [10, 20, 30, 40, 50],
    processing: true,
    searching: true,
    scrollX: true,
    autoWidth: false,
    language: this.spanish_datatables,
    dom: "<'pull-left'f>t<'bottom'lp><'clear'>",
    "drawCallback": function (settings: any) {
      $('.dataTables_scrollBody').css({ "overflow": "auto" });
      $('.bottom').css("margin-top", "1%");
      $(".paginate_button").css("background", "none").css("border-radius", "4px").css("padding", "0.3em 0.7em").css("font-size", "1.4rem").css("opacity", "1 !important");
      $(".paginate_button").hover(function () {
        $(this).css('cssText', 'color: black !important; background: none; border-radius: 4px; padding: 0.3em 0.7em; font-size:1.4rem')
      });
    },
    columnDefs: [{
      "targets": "_all",
      "width": "auto"
    }]
  }
  public static readonly dtOptionDefaultSearchRight = {
    pagingType: 'simple_numbers',
    pageLength: 10,
    lengthMenu: [[5, 10, 20, -1] , [5, 10, 20, 100]],
    processing: true,
    searching: true,
    scrollX: true,
    autoWidth: false,
    dom: "<'pull-right'f>t<'bottom'>lp",
    language: this.spanish_datatables2,
    "drawCallback": () => {
      $(".th-mensaje-observaciones").css("cssText", "max-width: 210px")
      $(".dataTables_filter").addClass('ocultar-mobile')
      $("#tabla-ponderacion_length").css("cssText", "margin-top: 1em")
      $("#tabla-ponderacion_paginate").css("cssText", "margin-top: 1em")
      this.drawCallBackFn()
    },
  }
  public static readonly blackboard_tabla = {
    processing: true,
    searching: false,
    dom: "t",
    language: this.spanish_datatables,
    columnDefs: [{
      "targets": "_all",
      "width": "auto"
    }],
  }
}